import React from 'react';

interface WhereItemProps {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  text: string;
  onClick: () => void;
}

const WhereItem = ({icon: Icon, text, onClick}: WhereItemProps) => {
  return (
    <button className='flex h-close shrink-0 items-center gap-x-[3px] p-1.25 text-c2 text-gray-50' onClick={onClick}>
      <Icon width={24} height={24} className='text-gray-40' />
      {/* 30자까지 표기, 31자부터 말줄임표시 */}
      <span>{text.length > 30 ? `${text.slice(0, 30)}...` : text}</span>
    </button>
  );
};

export default WhereItem;
